import { render, staticRenderFns } from "./TrophyIcon.vue?vue&type=template&id=194c1794&"
import script from "./TrophyIcon.vue?vue&type=script&lang=js&"
export * from "./TrophyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports